export default {
    BASE_URL: '/admin/crm/mem/cost',
    api: [
        {
            name: 'list',
            desc: '获取列表',
            method: 'GET',
            path: '/audit/record/list'
        },
        {
            name: 'detail',
            desc: '获取交易详情',
            method: 'GET',
            path: '/record/detail'
        },
        {
            name: 'audit',
            desc: '审核',
            method: 'PUT',
            path: '/audit'
        },
        {
            name: 'offline_top_up',
            desc: '后台线下充值',
            method: 'POST',
            path: '/remittance'
        },
        {
            name: 'detail_list',
            desc: '明细列表',
            method: 'GET',
            path: '/summary/list'
        },
        {
            name: 'pay_detail',
            desc: '缴费明细',
            method: 'GET',
            path: '/pay_detail/list'
        },
        {
            name: 'transcation_flow',
            desc: '交易流水',
            method: 'GET',
            path: '/transact/flow'
        },
        {
            name: 'remind_list',
            desc: '缴费提醒列表',
            method: 'GET',
            path: '/remind/list'
        },
        {
            name: 'remind_roles',
            desc: '联系人',
            method: 'GET',
            path: '/remind/roles'
        },
        {
            name: 'remind_send',
            desc: '缴费提醒发送短信',
            method: 'POST',
            path: '/remind/send'
        },
        {
            name: 'stats_dashboard',
            desc: '会费统计数据简报',
            method: 'GET',
            path: '/stats/dashboard'
        },
        {
            name: 'stats_arrear_amount',
            desc: '会费统计会费缴费情况',
            method: 'GET',
            path: '/stats/arrear_amount'
        },
        {
            name: 'stats_arrear_member',
            desc: '会费统计数会员缴费情况',
            method: 'GET',
            path: '/stats/arrear_member'
        },
        {
            name: 'stats_member_level',
            desc: '会费统计各会员等级缴费情况',
            method: 'GET',
            path: '/stats/member_level'
        },
        {
            name: 'stats_chapter',
            desc: '会费统计各分会会员缴费情况',
            method: 'GET',
            path: '/stats/chapter'
        },
        {
          name: 'checkHasAuditing',
          desc: '检查是否有审核中的会费缴纳交易记录',
          method: 'GET',
          path: '/checkHasAuditing/{id}'
        },
        {
            name: 'contactInfo',
            desc: '获取企业上次缴费邮寄信息',
            method: 'GET',
            path: '/last/contactInfo/{id}'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/member/fee.js